import React, { useEffect } from 'react';
import { App, message as staticMessage } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';

let currentMessage: MessageInstance | null = null;

function getMessageInstance(): MessageInstance {
  return currentMessage ?? staticMessage;
}

export const appMessage = {
  success: (...args: Parameters<MessageInstance['success']>) => getMessageInstance().success(...args),
  error: (...args: Parameters<MessageInstance['error']>) => getMessageInstance().error(...args),
  warning: (...args: Parameters<MessageInstance['warning']>) => getMessageInstance().warning(...args),
  info: (...args: Parameters<MessageInstance['info']>) => getMessageInstance().info(...args),
  loading: (...args: Parameters<MessageInstance['loading']>) => getMessageInstance().loading(...args),
  open: (...args: Parameters<MessageInstance['open']>) => getMessageInstance().open(...args),
  destroy: (...args: Parameters<MessageInstance['destroy']>) => getMessageInstance().destroy(...args),
};

export const AntdAppBridge: React.FC = () => {
  const { message } = App.useApp();

  useEffect(() => {
    currentMessage = message;

    return () => {
      if (currentMessage === message) {
        currentMessage = null;
      }
    };
  }, [message]);

  return null;
};